import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var zIndex = _ref.zIndex;
  return {
    root: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: zIndex
    }
  };
});
export default useStyles;